<template>
    <div class="fullprog">

        <div class="fullprog" v-if="clientProg">
            <Nav v-if="this.$route.name == 'historique'" />
            <!--<Profil />-->

            <div class="prog_body">

                <div v-if="this.$route.name == 'Historique'" class="grid-7 element-animation mobile-v">
                    <div class="card color-card">
                        <ul class="edit-info">

                            <i class="fa-regular fa-user-pen i-r w" @click="$bvModal.show('bv-modal-update')"></i>

                        </ul>
                        <div class="n-abbr">
                            <div class="name_abbr">

                                <h1>{{ firstletter() }}</h1>
                            </div>
                        </div>
                        <h1 class="title">{{ clientProg.nom.charAt(0).toUpperCase() + clientProg.nom.slice(1) }} {{
                            clientProg.prenom.charAt(0).toUpperCase() + clientProg.prenom.slice(1)
                        }}</h1>

                        <p class="job-title"><i class="fa-solid fa-envelope info-icon"></i>{{ clientProg.email }}</p>
                        <p class="job-title"><i class="fa-solid fa-phone info-icon"></i>{{ clientProg.telephone }}</p>
                        <p class="job-title"><i class="fa-solid fa-location-dot info-icon"></i>{{ clientProg.adresse }}
                        </p>

                        <hr>

                        <div class="content">
                            <div class="grid-2">
                                <button class="color-b circule"><i class="fa-solid fa-face-tongue-money fa-2x"></i>
                                </button>
                                <h2 class="title">{{ calculCredit() }}</h2>
                                <p class="followers">$</p>
                            </div>
                            <div class="grid-2">
                                <button class="color-c circule"><i class="fa-solid fa-star fa-2x"></i></button>
                                <h2 class="title">{{ calculEarn() }}</h2>
                                <p class="followers">Points</p>
                            </div>

                        </div>

                    </div>
                </div>

                <div class="grid-7 element-animation desktop-v">
                    <div class="card color-card">
                        <ul class="edit-info">

                            <i class="fa-regular fa-user-pen i-r w" @click="$bvModal.show('bv-modal-update')"></i>

                        </ul>

                        <div class="info-wrapper">
                            <div class="second-wrapper">
                                <div class="n-abbr">
                                    <div class="name_abbr">

                                        <h1>{{ firstletter() }}</h1>
                                    </div>
                                </div>
                                <h1 class="title">{{ clientProg.nom.charAt(0).toUpperCase() + clientProg.nom.slice(1) }}
                                    {{
                                        clientProg.prenom.charAt(0).toUpperCase() + clientProg.prenom.slice(1)
                                    }}</h1>

                                <p class="job-title"><i class="fa-solid fa-envelope info-icon"></i>{{ clientProg.email
                                }}
                                </p>
                                <p class="job-title"><i class="fa-solid fa-phone info-icon"></i>{{ clientProg.telephone
                                }}
                                </p>
                                <p class="job-title"><i class="fa-solid fa-location-dot info-icon"></i>{{
                                    clientProg.adresse
                                }}
                                </p>
                            </div>
                            <div class="content">
                                <div class="grid-2">
                                    <button class="color-b circule"><i class="fa-solid fa-face-tongue-money fa-2x"></i>
                                    </button>
                                    <h2 class="title">{{ calculCredit() }}</h2>
                                    <p class="followers">$</p>
                                </div>
                                <div class="grid-2">
                                    <button class="color-c circule"><i class="fa-solid fa-star fa-2x"></i></button>
                                    <h2 class="title">{{ calculEarn() }}</h2>
                                    <p class="followers">Points</p>
                                </div>

                            </div>
                        </div>

                    </div>
                </div>

                <!-- <div class="dtls_cmd_dsng element-animation">
                    <div class="col-lg-6 menu-wrap" style="background-color:#fff">
                        <div class="bande_header">
                            <div class="hist_title">
                                <h4>Vos commandes en cours</h4>
                            </div>
                        </div>
                        <div class="commandes" v-if="(reserveditems.length > 0)">

                            <div class="text-wrap" v-for="item in reserveditems" :key="item._id">
                                <div class="row align-items-start" v-if="(item.quantity > 0)">
                                    <div class="order_restau">
                                        <img :src="`htttp://localhost:3333/uploads/menus-items/${item.image}`"
                                            class="fact_item_image" alt="" srcset="" />
                                        <h3>{{ item.title }}</h3>
                                    </div>
                                    <div class="order_info">
                                        <h6 class="text-muted menu-price">{{ item.price }} $</h6>
                                        <h6 class="text-muted menu-price">{{ item.quantity }} Points</h6>
                                        <h6 class="text-muted menu-price">{{ (item.price * item.quantity).toFixed(2) }}
                                            $</h6>
                                    </div>
                                    <div class="order_status">
                                        <h6>Non payée</h6>
                                        <h4># {{ lastfour(item.objectNumber) }}</h4>
                                    </div>
                                </div>


                            </div>
                        </div>
                        <div v-else class="commandes">
                            <p style="font-size:15px;color: #666B7D;">Aucune commande en cours</p>
                        </div>
                    </div>
                </div>-->



                <!--AFFICHAGE DE L'HISTORIQUE
                <div v-if="!show" class="choose">
                    <div class="c ">ALL</div>
                    <div class="c " @click="show = !show"><i class="fa-solid fa-sort fa-2x"></i></div>
                </div>
            -->

                <div v-if="!show" class="dtls_cmd_dsng element-animation">
                    <div v-if="!show" class="col-lg-6 menu-wrap">

                        <div class="profile_orders_title">
                            <span>Vos anciennes commandes <div class="dot_profile_page3"></div></span>

                            <div class="profile_orders_title_button"
                                @click="$modal.hide('profile'), $modal.show('historique'), show = !show, showDate(datev)">
                                Filtrer
                            </div>
                        </div>


                        <div class="profile_orders">
                            <div class="profile_order" v-for="comnd in cltprg" :key="comnd._id">
                                <div v-if="comnd.commande" class="profile_order_menu">
                                    <span>{{ comnd.commande.menu }}</span>
                                </div>
                                <div v-if="comnd.commande" class="profile_order_infos">
                                    <span>{{ comnd.commande.menu_items.length }} Articles</span>
                                    <div></div>
                                    <span v-if="comnd.total">{{ comnd.total }} {{ comnd.commande.currency_code }}</span>
                                    <span v-else-if="comnd.commande.Due">{{ textToDouble(comnd.commande.Due._text) }} {{
                                        comnd.commande.currency_code }}</span>
                                    <span v-else>0</span>
                                    <div></div>
                                    <span>{{ extractDate(comnd.commande.date) }}</span>
                                </div>

                                <div v-if="comnd.commande" class="profile_order_state">
                                    <div class="profile_order_ref">
                                        <span>REF : {{ lastfour(comnd.commande.ref) }}</span>
                                    </div>
                                    <div class="profile_order_ref1" @click="showModal('modalcmd', comnd)">
                                        <span>Details</span>
                                    </div>
                                </div>
                            </div>

                        </div>
                    </div>
                </div>

                <!--AFFICHAGE PAR DATE
                <div v-if="show" class="choose">

                    <div class="c" @click="show = !show">ALL</div>
                    <div class="c"><i class="fa-regular fa-sort fa-2x"></i></div>

                </div>
            -->

                <div v-if="show" class="cmdpardate">
                    <div class="dtls_cmd_dsng element-animation">
                        <div v-if="show" class="col-lg-6 menu-wrap">
                            <!--<div class="bande_header">
                                <div class="hist_title">
                                    <h4>Tri par date</h4>
                                </div>
                                <div v-if="show" class="pickmonth">
                                    <month-picker-input @change="showDate"></month-picker-input>
                                </div>
                            </div>
                            <div class="commandes" v-for="cmnd in cltprgpardate" :key="cmnd._id">

                                <div class="text-wrap">
                                    <div class="row align-items-start">
                                        <div class="order_restau">
                                            <h2>{{ cmnd.commande.restau }}</h2>
                                        </div>
                                        <div class="order_info">
                                            <h6>{{ extractDate(cmnd.commande.date) }}</h6>
                                            <h6 class="text-muted menu-price">{{ cmnd.commande.total }} $</h6>
                                            <h6 class="text-muted menu-price">{{ cmnd.points }} Points</h6>
                                        </div>
                                        <div class="order_status">
                                            <h6>Payé</h6>
                                            <h4># {{ lastfour(cmnd.commande.CheckNum) }}</h4>
                                        </div>
                                    </div>
                                    <div class="article_list">
                                        <p style="color: #666B7D;" v-for="item in cmnd.commande.menu_items"
                                            :key="item._id">{{
                                                    item.title
                                            }}</p>
                                    </div>
                                </div>
                                <div class="menu-img rounded-circle" @click="showModal('modalcmd', comnd)">
                                    <img class="img-fluid" src="../../../public/illustrations/eyes/eyeO64.png" alt="">
                                </div>
                            </div>-->
                            <div class="profile_orders_title">
                                <div v-if="show" class="pickmonth">
                                    <div id="app">
                                        <v-app id="inspire"
                                            style="background-color: #fff;height: 50px;padding: 0 15px;border-radius: 5px;">
                                            <v-row>
                                                <v-col cols="" sm="5">
                                                    <v-menu ref="menu" v-model="menu" :close-on-content-click="false"
                                                        :return-value.sync="datev" transition="scale-transition" offset-y
                                                        max-width="290px" min-width="auto">
                                                        <template v-slot:activator="{ on, attrs }">
                                                            <v-text-field v-model="datev" label="Picker in menu"
                                                                prepend-icon="mdi-calendar" readonly v-bind="attrs"
                                                                v-on="on"></v-text-field>
                                                        </template>
                                                        <v-date-picker v-model="datev" type="month" no-title scrollable
                                                            style="height: auto;">

                                                            <v-btn text color="primary" @click="menu = false"
                                                                style="width: 50%;">
                                                                Cancel
                                                            </v-btn>
                                                            <v-btn text color="primary"
                                                                @click="$refs.menu.save(datev), showDate(datev)"
                                                                style="width: 50%;">
                                                                OK
                                                            </v-btn>
                                                        </v-date-picker>
                                                    </v-menu>
                                                </v-col>
                                            </v-row>
                                        </v-app>
                                    </div>
                                    <!-- <month-picker-input @change="showDate"
                                        style="background-color: #fff;"></month-picker-input>-->
                                </div>
                                <div class="profile_orders_title_button"
                                    @click="$modal.hide('profile'), $modal.show('historique'), show = !show">
                                    Toutes
                                </div>
                            </div>


                            <div class="profile_orders">
                                <div class="profile_order" v-for="comnd in cltprgpardate" :key="comnd._id">
                                    <div v-if="comnd.commande" class="profile_order_menu">
                                        <span>{{ comnd.commande.menu }}</span>
                                    </div>
                                    <div v-if="comnd.commande" class="profile_order_infos">
                                        <span>{{ comnd.commande.menu_items.length }} Articles</span>
                                        <div></div>
                                        <span>{{ comnd.total }} {{ comnd.commande.currency_code }}</span>
                                        <div></div>
                                        <span>{{ extractDate(comnd.commande.date) }}</span>
                                    </div>

                                    <div v-if="comnd.commande" class="profile_order_state">
                                        <div class="profile_order_ref">
                                            <span>REF : {{ lastfour(comnd.commande.ref) }}</span>
                                        </div>
                                        <div class="profile_order_ref1" @click="showModal('modalcmd', comnd)">
                                            <span>Details</span>
                                        </div>
                                    </div>
                                </div>

                            </div>


                        </div>
                    </div>


                </div>

                <div>
                    <b-modal id="bv-modal-update" modal-class="modal-center modalTagNew" hide-footer>
                        <!-- <template #modal-title>
                            Modifiez votre profil
                        </template>-->
                        <div class="d-block text-center">
                            <b-form class="av-tooltip tooltip-label-right">


                                <fieldset>
                                    <legend>Modifier votre profil</legend>
                                    <b-form-group :label="`Nom`" class="label-style">
                                        <b-form-input type="text" v-model="formedit.nom" />
                                        <b-form-invalid-feedback>Nom du programme est
                                            obligatoire</b-form-invalid-feedback>
                                    </b-form-group>
                                    <b-form-group :label="`Prénom`" class="label-style">
                                        <b-form-input type="text" v-model="formedit.prenom" />
                                        <b-form-invalid-feedback>Nom du programme est
                                            obligatoire</b-form-invalid-feedback>
                                    </b-form-group>
                                    <b-form-group :label="`email`" class="label-style">
                                        <b-form-input type="email" v-model="formedit.email" />
                                        <b-form-invalid-feedback>Nom du programme est
                                            obligatoire</b-form-invalid-feedback>
                                    </b-form-group>
                                    <b-form-group :label="`adresse`" class="label-style">
                                        <b-form-input type="text" v-model="formedit.adresse" />
                                        <b-form-invalid-feedback>Nom du programme est
                                            obligatoire</b-form-invalid-feedback>
                                    </b-form-group>
                                    <b-form-group :label="`Téléphone`" class="label-style">
                                        <b-form-input type="text" v-model="formedit.telephone" />
                                        <b-form-invalid-feedback>Nom du programme est
                                            obligatoire</b-form-invalid-feedback>
                                    </b-form-group>

                                </fieldset>

                            </b-form>
                        </div>
                        <b-button class="mt-3 submitedit" block
                            @click="submitForm('bv-modal-update'); $bvModal.hide('bv-modal-update')">Submit
                        </b-button>
                    </b-modal>
                </div>
            </div>

            <b-modal id="modalcmd" ref="modalcmd" hide-footer hide-header>
                <div class="dark_header" @click="$bvModal.hide('modalcmd')">
                    <img src="htttp://localhost:3333/new_images/orange_left_arrow.png" alt="" srcset="" />
                </div>
                <div v-if="commande" class="cmddetails">
                    <div class="dot_commande_page"></div>
                    <div class="dot_commande_page1"></div>
                    <div class="dot_commande_page2"></div>
                    <div class="dot_commande_page3"></div>
                    <div class="dot_commande_page4"></div>
                    <div class="refdate">
                        <span class="cmdreference">{{ commande.commande.ref }}</span>
                        <span class="cmddate">{{ extractDate(commande.commande.date) }} </span>
                    </div>
                    <table class="table">
                        <tr>
                            <th scope="col">Articles</th>
                            <th scope="col">Quantité</th>
                            <th scope="col">Prix</th>
                        </tr>

                        <tr v-for="item in commande.commande.menu_items" :key="item._id">

                            <td>
                                {{ item.title }}
                            </td>
                            <td>
                                {{ item.quantity }}
                            </td>
                            <td>{{ item.quantity * item.price }} {{ commande.commande.currency_code }}</td>

                        </tr>
                        <tr>
                            <td colspan="2">Total:</td>
                            <td v-if="commande.total">{{ commande.total }} {{ commande.commande.currency_code }}</td>
                            <td v-else-if="commande.commande.Due">{{ textToDouble(commande.commande.Due._text) }} {{ commande.commande.currency_code }}</td>
                            <td v-else>0</td>
                        </tr>
                        <tr v-if="commande.points > 0">
                            <td colspan="2">Vous avez gagné:</td>
                            <td>{{ commande.points }} Points</td>
                        </tr>
                        <tr v-if="commande.points < 0">
                            <td colspan="2">Vous avez consommé:</td>
                            <td>{{ commande.points }} Points</td>
                        </tr>
                    </table>
                </div>
                <div class="download" @click="startDownload">
                    <button class="download_button">Télécharger</button>
                </div>
            </b-modal>

            <notifications group="edit-success" />
        </div>
        <div v-else>
            <div class="center_all">
                <span>
                    Connectez-vous pour voir vos commandes
                </span>
                <button class="login_button" @click="$modal.hide('historique'), $modal.show('login')">Login</button>
            </div>


        </div>
        <!--<h1 v-else>Hello </h1>-->
    </div>
</template>


<script>
import Nav from './Nav.vue'
// import Profil from './Profil.vue'

import { mapGetters, mapActions, mapMutations } from "vuex";
import { MonthPickerInput } from 'vue-month-picker'
import moment from "moment"


export default {
    data() {

        var datefilter = new Date()
        return {
            isLoad: false,
            datefilter: datefilter,

            commande: "",

            datev: new Date().toISOString().substr(0, 7),
            menu: false,
            modal: false,

            show: false,

            min: null,
            max: null,
            date: {
                from: null,
                to: null,
                month: null,
                year: null
            },

            formedit: {
                nom: "",
                prenom: "",
                email: "",
                adresse: "",
                telephone: "",
            },

        }
    },
    props: [
        "reserveditems"
    ],
    components: {
        Nav,
        // Profil,
        // 'Nav':Nav ,
        MonthPickerInput,

    },
    // watch : {
    //     "datev" : function (){
    //         console.log(this.datev)
    //     }
    // },  
    computed: {
        ...mapGetters(["clientProg", "cltprg", "cltprgpardate"]),

    },

    methods: {
        ...mapActions(["getClientProg", "filterbydate", "editClient", "downloadFile"]),
        ...mapMutations(["getClientSuccess", "getCltDateSuccess"]),
        textToDouble(_text) {
            let total = parseFloat(_text);
            return total.toFixed(2);
        },
        startDownload() {
            this.downloadFile(this.commande.commande);
        },
        clg(date) {
            console.log(date)
        },
        showDate(date) {

            // const now = new Date()
            // let datefilter = this.datefilter
            //const today = new Date(datefilter.getMonth(), datefilter.getDate())
            //this.datefilter= today


            // *******Décommenter ce code pour avoir l'ancienne version de month picker*******
            // this.date = date
            // let dt = this.date
            // let datemax = moment(dt.from).endOf('month').format()
            // console.log(datemax)
            // datemax = moment(datemax, moment.ISO_8601)
            // let datemin = moment(dt.from).startOf('month').format();
            // console.log(datemin)
            // datemin = moment(datemin, moment.ISO_8601)


            let dtv = date

            let datemax_v = moment(dtv).endOf('month').format()
            console.log(datemax_v)
            datemax_v = moment(datemax_v, moment.ISO_8601)
            let datemin_v = moment(dtv).startOf('month').format();
            console.log(datemin_v)
            datemin_v = moment(datemin_v, moment.ISO_8601)
            console.log(moment(this.datev).startOf('month').format())
            console.log(moment(this.datev).endOf('month').format())

            let payload = {
                maxdate: datemax_v,
                mindate: datemin_v,

            }
            this.filterbydate(payload)
            // return {
            //     maxdate: maxdate,
            //     mindate: mindate
            // }
            // let mindate=moment(this.datefilter).startOf('month').format("YYYY-MM-DD")
        },
        logout() {
            localStorage.setItem("accessToken", "")
            setTimeout(() => {
                this.$router.push({ name: 'Login' })
            }, 200)
        },
        responav() {
            var x = document.getElementById("myTopnav");
            if (x.className === "topnav") {
                x.className += " responsive";
            } else {
                x.className = "topnav";
            }
        },
        gotoprofil() {
            this.$router.push({ name: 'Client' })
        },
        showModal(refname, cmd) {
            this.commande = cmd;

            this.$refs[refname].show();
        },
        firstletter() {
            let nom = Array.from(this.clientProg.nom)[0].toUpperCase();
            let prenom = Array.from(this.clientProg.prenom)[0].toUpperCase();
            let nomcom = nom.concat(' ', prenom)
            return nomcom
        },
        lastfour(checknum) {
            var lastfour = checknum.substr(checknum.length - 4);
            return lastfour;

        },
        generateReport(cmd) {
            // this.changecmd(cmd).then(() => {
            // this.$refs.html2Pdf.generatePdf()
            // })
            this.commande = cmd;
            console.log("VOICI LA COMMANDE" + this.commande.commande.CheckNum)
            this.$refs.html2Pdf.generatePdf()

        },

        extractDate(date) {
            let datec = moment(date).format("YYYY-MM-DD")
            return datec;
        },
        calculEarn() {
            let ttl = 0;
            for (let i = 0; i < this.cltprg.length; i++) {
                ttl = ttl + this.cltprg[i].points
            } return ttl.toFixed(2)
        },
        calculCredit() {
            let ttl = 0;
            for (let i = 0; i < this.cltprg.length; i++) {
                if (this.cltprg[i].total) {
                    ttl = ttl + this.cltprg[i].total
                }
            } return ttl.toFixed(2)
        },
        submitForm(refname) {
            const form = {
                // id: this.$route.params.id,
                nom: this.formedit.nom,
                prenom: this.formedit.prenom,
                email: this.formedit.email,
                adresse: this.formedit.adresse,
                telephone: this.formedit.telephone,
            };
            this.editClient({ form }).then((res) => {
                if (res.ok) {
                    this.$notify({
                        group: "edit-success",
                        type: "success",
                        title: "Réussi",
                        text:
                            "Vous avez modifié votre profil avec succes"
                    });
                }
            });
        }
    },
    mounted() {

        this.getClientProg().then((res) => {
            // if (res.err) {
            //     this.$router.push({ name: 'Login' })

            // } else {
            this.isLoad = true;
            console.log(this.clientProg)
            // console.log(this.cltprg)
            this.formedit = {
                nom: this.clientProg.nom,
                prenom: this.clientProg.prenom,
                email: this.clientProg.email,
                adresse: this.clientProg.adresse,
                telephone: this.clientProg.telephone,
            }
            console.log(this.formedit)

            // }
        });


    }
}
</script>


<style scoped>
.fullprog {
    width: 100%;
    height: 100%;
    /* background-color: #f6f3f1; */
    background-color: #264740;
    box-sizing: border-box;

}

.center_all {
    background-color: #264740;

    display: flex;
    width: 100%;
    height: 60vh;
    justify-content: center;
    align-content: center;
    padding-top: 30vh;
    flex-direction: column;
}

.login_button {

    background: #f05d2e;
    color: #fff;
    /* padding: 12px; */
    text-align: center;
    display: flex;
    justify-content: center;
    /* margin: 0px 6px; */
    align-items: center;
    padding: 12px;
    font-size: 12px;
    border-radius: 151px;
}

.prognav {
    display: flex;
    width: calc(100% - 24px);
    justify-content: space-between;
    padding: 12px;
    align-items: center;
}

.menu_prog div {
    width: 30px;
    height: 3px;
    background: black;
    border-radius: 5px;
    margin: 3px;
}

.logo_prog {
    width: 60px;
}

.prog_body {
    /* margin-top: 2%; */
    display: flex;
    justify-content: center;
    align-items: center;
    flex-direction: column;
}

.profil_clt {
    height: auto;
    background-color: #264740;
    margin: 20px auto;
    display: flex;
    flex-direction: row;
    padding: 30px;
    width: calc(100% - 48px);
    justify-content: center;
    align-items: center;
    border-radius: 5px;
}

.n-abbr {
    display: flex;
    justify-content: center;
    align-items: center;
    margin: 10px;
}

.name_abbr {

    color: #264740;
    display: flex;
    justify-content: center;
    align-items: center;
    width: 100px;
    background-color: #fff;
    height: 100px;
    border-radius: 50%;
}


.infos_profil {
    color: #fff;
    margin: 0 50px;
    /* width: 100px; */
    /* background-color: black; */
    text-align: start;
}

.info {
    margin: 10px 0;
}

.title_pts {
    color: #f05d2e;
    background-color: #fff;
    width: 60%;
    margin: 20px auto;
    height: 50px;
    /* padding: 20px; */
    display: flex;
    justify-content: center;
    align-items: center;
    border-radius: 15px;
    border: 1px solid #f05d2e;

}

.prog_points {
    padding: 24px;
    width: 100%;
    display: flex;
    justify-content: center;
    align-items: center;
    margin: 20px auto;

}

.prog_point {
    padding: 12px;
    background: #f05d2e;
    width: 48%;
    height: 90px;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    color: #fff;
    border-radius: 5px;
}

.profile_orders {
    display: flex;
    flex-direction: column;
    margin-top: 18px;
}

.profile_order {
    background-color: #fff;
    color: #264740;
    padding: 12px;
    margin: 3px 0px;
    border-radius: 5px;
}

.profile_order_menu {
    font-size: 20px;
    font-weight: bold;
    text-align: left;
    margin-bottom: 6px;

}

.profile_order_menu span {}

.profile_order_infos {
    width: 100%;
    display: flex;
    align-items: center;
}

.profile_order_infos span {
    flex: 1;
    font-size: 14px;
    font-weight: 500;
}

.profile_order_infos div {
    width: 6px;
    height: 6px;
    background: #f05d2e;
    border-radius: 50%;

}

.profile_order_state {
    display: flex;
    justify-content: space-between;
}

.profile_order_ref {
    background: #264740;
    color: #fff;
    border-radius: 5px;
    padding: 3px 12px;
    font-size: 14px;
    margin-top: 6px;
}

.profile_order_ref1 {
    background: #f05d2e;
    color: #fff;
    border-radius: 5px;
    padding: 3px 12px;
    font-size: 14px;
    margin-top: 6px;
}

.profile_orders_title {
    display: flex;
    justify-content: space-between;
    background: transparent;
    color: #f05d2e;
    align-items: center;
    position: relative;
    border-radius: 5px;
    margin-top: 12px;
}

.profile_orders_title span {
    flex: 1;
    padding: 12px;
    color: #fff;
    text-align: left;
    font-size: 18px;
    font-weight: bold;
}

.profile_orders_title_button {
    padding: 12px;
    background: #fff;
    color: #264740;
    border-radius: 5px;
    text-decoration: underline;
}

.dot_commande_page {
    width: 30px;
    height: 30px;
    border-radius: 50%;
    background: #f05d2e;
    position: absolute;
    top: 35%;
    left: 10%;
}

.dot_commande_page1 {
    width: 30px;
    height: 30px;
    border-radius: 50%;
    background: #f05d2e;
    position: absolute;
    top: 10%;
    left: 52%;
}

.dot_commande_page2 {
    width: 30px;
    height: 30px;
    border-radius: 50%;
    background: #f05d2e;
    position: absolute;
    top: 25%;
    right: 20%;
}

.dot_commande_page3 {
    width: 30px;
    height: 30px;
    border-radius: 50%;
    background: #f05d2e;
    position: absolute;
    top: 70%;
    right: 10%;
}

.dot_commande_page4 {
    width: 30px;
    height: 30px;
    border-radius: 50%;
    background: #f05d2e;
    position: absolute;
    top: 57%;
    right: 50%;
}

.dot_profile_page3 {
    width: 6px;
    height: 6px;
    border-radius: 50%;
    background: #f05d2e;
    display: inline-block;
}


.title_cmd {
    color: #264740;
    background-color: #fff;
    width: 60%;
    margin: 20px auto;
    height: 50px;
    /* padding: 20px; */
    display: flex;
    justify-content: center;
    align-items: center;
    border-radius: 15px;
    border: 1px solid #264740;
}

.filterbydate {
    display: flex;
    justify-content: flex-end;
    align-items: center;
    width: 80%;
}

.filterbydate .date {
    width: 35%;
}

.choose {
    display: flex;
    justify-content: center;
    align-items: center;
    /* margin-top: 2%; */
    /* width: 80%; */
}

.choose .c {

    margin-right: 5px;
    background-color: #f05d2e;
    height: 35px;
    display: flex;
    justify-content: center;
    align-items: center;
    padding: 10px;
    border-radius: 10px;
    color: #fff;
    cursor: pointer;
}

.monthpicker {
    display: flex;
    justify-content: center;
    align-items: center;
    margin: 10px auto;
}

.label-style {
    border-bottom: 1px solid #264740;
}

.cmdpardate {
    /* margin: 20px auto; */
    display: flex;
    flex-direction: row;
    width: 100%;
    justify-content: center;
    align-items: center;
    border-radius: 5px;
}

.cmdpardate table {
    width: auto;
}

.menu-wrap {

    width: 100%;
    border-radius: 10px;
}




.menu-img {
    overflow: hidden;
    height: 30px;
    width: 30px;
    cursor: pointer
}

.menu-img img {
    transition: all .5s ease;
    /* height: 100%; */
    object-fit: cover;
}


.commandes {
    display: flex;
    justify-content: space-around;
    align-items: center;
    /* padding-bottom: 15px;
    margin-bottom: 15px; */
    border-bottom: 1px dashed #ccc;
    padding: 15px;
    width: 100%;
}

.commandes p {
    margin-bottom: 0;
    display: flex;
    padding: 0 15%;
}

.commandes .text-wrap {
    width: calc(100% - 95px);
    margin-left: 15px;
    color: #666B7D;
}

.commandes .text-wrap h4 {
    font-size: 20px;
    font-weight: 300;
}

.commandes .text-wrap h6 {
    font-weight: 300;
}

.menu-price {
    text-align: right;
}

.commandes .order_info {
    display: flex;
    justify-content: space-between;
    align-items: center;
    width: 90%;
}

.order_status {
    display: flex;
    /* justify-content: space-around; */
    justify-content: flex-start;
    align-items: center;
}

.order_status h4,
.order_status h6 {
    width: 40%;
    background-color: #264740;
    color: #fff;
    border-radius: 15px;
    margin: 0 15px 0 0;
}

.article_list {
    display: flex;
    justify-content: flex-start;
    align-items: center;
    flex-direction: column;
    width: 60%;
}

.order_restau {
    display: flex;
    justify-content: flex-start;
}

.refdate {
    display: flex;
    justify-content: space-between;
    align-items: center;
    height: 100px;
    margin: 20px 0;
}

.refdate .cmdreference {
    border: 1px solid #264740;
    border-radius: 5px;
    padding: 20px;
    transform: rotate(-10deg);
}

.refdate .cmddate {
    background-color: #264740;
    border-radius: 5px;
    padding: 10px;
    color: #fff;
}

.cmd_details {
    display: flex;
    justify-content: center;
    align-items: center;
    flex-direction: column;
    /* background-color: #264740; */
    /* margin: 0; */
    width: 100%;
}

.commande-ligne {
    display: flex;
    justify-content: space-between;
    /* align-items: flex-start; */
    width: 100%;
}

.cmd_details h4 {
    text-transform: uppercase;
    margin: 5px 0;
    text-align: center;
    background-color: #264740;
    padding: 10px;
    color: #fff;
    border-radius: 10px;
}

.cmd_details .dtl_cmd {

    margin: 5px 0;
    display: flex;
    align-items: center;
}

.cmd_details .dtl_cmd ul {
    padding: 0;
}

.cmd_details h4 {
    margin: 20px 0;
}

.cmddetails {
    margin-top: 50px;
}

.cmddetails table {
    width: 100%;
    font-size: 30px;
    margin: 50px 0;
}

.table td,
.table th {
    font-size: 14px;
    width: 25%;
    /* text-align: center; */
}

.download {
    width: 100%;
    display: flex;
    justify-content: flex-end;
    align-items: center;
}

.download .download_button {
    width: 35%;
    font-size: 14px;
    background-color: #f05d2e;
    color: #fff;
}

.dtls_cmd_dsng {
    width: 85%;
    height: 100%;
    border-radius: 6px;
    margin: 20px 0;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
}

.dtls_cmd_dsng .containercmd {
    display: flex;
    justify-content: center;
    align-items: center;
    width: 100%;
}

.bande_header {
    color: #666B7D;
    display: flex;
    justify-content: space-between;
    align-items: center;
    flex-direction: row;
    padding: 20px 20px;

}


.dtls_cmd_dsng .cmddtl {
    display: flex;
    justify-content: space-between;
    align-items: center;
    color: #264740;
    padding: 10px 5px;
    margin: 30px 2%;
    border-bottom: 1px solid #fff;
    background-color: #fff;
    border-radius: 30px;
    cursor: pointer;
    width: 50%;
}

.dtls_cmd_dsng .cmddtl .ch_n {
    display: flex;
    background-color: #f05d2e;
    padding: 3%;
    border-radius: 20px;
    color: #f6f3f1;
}

.edit {
    background-color: #f05d2e !important;
    border-radius: 5px !important;
    border: 0;
}

@media screen and (max-width: 600px) {

    .grid-7 {
        margin-top: 0;
    }

    .dtls_cmd_dsng {
        width: 95%;
    }

    .dtls_cmd_dsng .cmddtl {
        width: 100%;
    }



    .menu-wrap {
        width: 100%;
    }

    .commandes {
        padding: 15px 0;

    }

    .commandes p {
        padding: 0 10%;
    }

    .commandes .text-wrap h4 {
        font-size: 18px;
    }


}
</style>

<style lang="scss" scoped>
@media screen and (max-width: 600px) {
    .v-menu__content {
        top: 80px !important;
        left: 12px !important;
    }
}

.color-card {
    background: #31394D;
}

.info-wrapper {
    display: flex;
    justify-content: center;
    align-items: center;
    width: 100%;
    margin-bottom: 3%
}

.second-wrapper {
    display: flex;
    justify-content: center;
    align-items: center;
    flex-direction: column;
    border-right: 1px solid #7C8097;
    width: 60%
}

.title {
    color: #ffffff;
    margin-top: 10px;
}

.followers {
    color: #666B7D;
    font-family: 10px;

}

.job-title {
    color: #7C8097;
    font-size: 12px;
}

.job-title .info-icon {
    margin-right: 5px;
}

.i-r {
    float: right;
    margin-right: 16px;
    margin-top: 16px;
    cursor: pointer;
}

.w {
    color: #ffffff;
    //   background-color: #fff;
}

hr {
    border-color: #7C8097;
    width: 90%;
    margin-top: 24px;
    margin-bottom: 24px;
    display: flex;
    align-self: center;
}

.content {
    display: flex;
    align-items: center;
    justify-content: center;
    width: 40%;
}

.color-b {
    background: linear-gradient(to bottom right, #f05d2e, #264740);
}

.color-c {
    background: linear-gradient(to bottom right, #264740, #f05d2e);
}

.circule {
    border-radius: 50%;
    border: none;
    height: 60px;
    width: 60px;
    color: #ffffff;
    box-shadow: 0 13px 26px rgba(0, 0, 0, 0.16), 0 3px 6px rgba(0, 0, 0, 0.16);
    display: flex;
    justify-content: center;
    align-items: center;
}

.grid-2 {
    width: 50%;
    display: flex;
    justify-content: center;
    align-items: center;
    flex-direction: column;
    margin: 5px;
}

.grid-7 {
    width: 80%;
    display: flex;
    justify-content: center;
    align-items: center;
    margin-top: 4%;
}


.card {
    border-radius: 6px;
    display: flex;
    justify-content: center;
    height: auto;
    position: relative;
    width: 80%;
    box-shadow: 0 12px 13px rgba(0, 0, 0, 0.16), 0 12px 13px rgba(0, 0, 0, 0.16);
    transition: all 0.3s cubic-bezier(.25, .8, .25, 1);
}

.element-animation {
    animation: animationFrames ease 2s;
    animation-iteration-count: 2;
    transform-origin: 50% 50%;
    animation-fill-mode: forwards;
    /*when the spec is finished*/
    -webkit-animation: animationFrames ease 1.5s;
    -webkit-animation-iteration-count: 1;
    -webkit-transform-origin: 50% 50%;
    -webkit-animation-fill-mode: forwards;
    /*Chrome 16+, Safari 4+*/
}

.submitedit {
    background-color: #264740;
    border-radius: 5px !important;
    border: 0;
}

@media (max-width :600px) {
    .card {
        width: 100%;
    }

    .content {
        width: 100%;
    }

}

@media screen and (max-width : 1920px) {
    .mobile-v {
        display: none;
    }
}

@media screen and (max-width : 906px) {
    .desktop-v {
        display: none;
    }

    .mobile-v {
        display: flex;
    }
}

@keyframes animationFrames {
    0% {
        opacity: 0;
        transform: translate(-1500px, 0px);
    }

    60% {
        opacity: 1;
        transform: translate(30px, 0px);
    }

    80% {
        transform: translate(-10px, 0px);
    }

    100% {
        opacity: 1;
        transform: translate(0px, 0px);
    }
}
</style>
